<template>
  <Transition
    enter-active-class="transition-opacity duration-500 ease-out"
    enter-from-class="opacity-0"
  >
    <div
      v-if="loaded"
      class="relative flex h-[104px] items-center justify-between gap-4 overflow-hidden rounded-[20px] bg-white px-6"
    >
      <div class="min-w-0">
        <p class="text-[14px] leading-tight">Wait Mate supporters</p>
        <p class="mt-1 text-[32px]/[0.9em] font-medium tracking-[-0.96px]">
          {{ formattedCount }}
        </p>
      </div>
      <div v-if="latest" class="relative h-16 w-[275px] shrink-0">
        <!-- A second card peeking out behind the latest supporter -->
        <div
          class="bg-grey absolute top-[18px] left-[13px] h-[58px] w-[249px] rounded-[11px] opacity-50"
        />
        <Transition :css="false" @enter="onEnter" @leave="onLeave">
          <div
            :key="latest.school"
            class="bg-grey absolute inset-0 flex items-center gap-3 rounded-xl px-3"
          >
            <img
              src="/images/pledge-supporter-avatar.svg"
              alt=""
              aria-hidden="true"
              class="size-10 shrink-0 rounded-full"
            />
            <div class="min-w-0">
              <p class="truncate text-[13px]/[1.4] font-medium">
                New commitment at
              </p>
              <p class="truncate text-[12px]/[1.2] text-black/50">
                {{ latest.school }}
              </p>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { GetStatsDocument } from '#graphql-exports'
import type { Stats } from '@/components/global-stats/types'

interface GetStatsQueryResult {
  Stats: Stats
}

const { result } = useQuery<GetStatsQueryResult>(GetStatsDocument, () => ({}), {
  prefetch: false,
  pollInterval: 10_000,
  skipPollAttempt: () => document.hidden,
})

const { onEnter, onLeave } = usePledgeCardSwap()

// Keep the whole card hidden until the query resolves so it never flashes a
// placeholder "0" before the real supporter count arrives.
const loaded = computed(() => result.value?.Stats != null)

const formattedCount = computed(() =>
  (result.value?.Stats.pledges ?? 0).toLocaleString('en-AU'),
)

const latest = computed(() => {
  const pledge = result.value?.Stats.latestPledge
  return pledge?.school ? pledge : null
})
</script>
